function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 1a7 7 0 00-5.603 11.197A12.116 12.116 0 018 10.833c2.02 0 3.925.493 5.602 1.364A7 7 0 008 1zm6.12 12.152A8 8 0 101.88 2.848a8 8 0 0012.24 10.305zm-1.195-.177A11.12 11.12 0 008 11.833c-1.768 0-3.44.411-4.924 1.142A6.978 6.978 0 008 15c1.92 0 3.66-.773 4.925-2.025zM8 4.333a2 2 0 100 4 2 2 0 000-4zm-3 2a3 3 0 116 0 3 3 0 01-6 0z",
  fill: "#2D2D2D"
});
function SvgPerfil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Perfil.svg";
export { SvgPerfil as ReactComponent };